import React from 'react';

export const inventoryRouteConfig = [
  {
    auth: ["Admin", "Pharmacists", "Pharmacy Assistants", "Warehouse", "Warehouse Assistant"],
    routes: [
      {
        path: '/inventory',
        exact: true,
        component: React.lazy(() => import('./Inventory')),
      },
      {
        path: '/inventory/:id/report',
        exact: true,
        component: React.lazy(() => import('./Report')),
      },
    ],
  },
];
